import * as Actions from '../actions'

const initialState = {}

const user = function userReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.SET_USER_PROJECT: {
      return {
        ...state,
        projects: action.payload,
      }
    }
    case Actions.SET_USER_SELECTED_PROJECT: {
      return {
        ...state,
        selectedProject: action.payload,
      }
    }
    case Actions.SET_USER_DATA: {
      return {
        ...state,
        ...action.payload,
      }
    }

    default: {
      return state
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/auth/store/reducers/user.reducer.js